import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

//package import

import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Chip,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { RoutesUrls, districtRoutes } from "../../../../Services/Routes/APP";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { headersPost } from "../../../../Services/API";
import { DetailsIcon } from "../../../../Svg";

//constants

const headings = ["Name", "Date", "Units Requested", "Actions"];

const rows = [
  {
    most_recent: "Sydney",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Queens Land",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Victoria",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Tasmania",
    date: "19-12-2021",
    units_requested: "10 K",
  },
];

//component

const Seemore = () => {
  const navigate = useNavigate();

  const addHandler = () => {
    navigate(RoutesUrls.districtAdmin + districtRoutes.dashboardDetails);
  };
  //hooks

  const theme = useTheme();

  //states

  const [tableData, setTableData] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [searchData, setSearchData] = useState("");

  // Get Dashboard API

  const getDashboardData = () => {
    const data = {
      dashboard_request: {
        view_level: "district",
      },
    };
    setLoaderOpen(true);

    headersPost(MINISTRY_API_ULRS.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setTableData(res.data?.received_requests);
          setLoaderOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
          setLoaderOpen(false);
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
          setLoaderOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
          setLoaderOpen(false);
        }
      });
  };
  const handleAlertClose = () => {
    setAlertOpen(false);
    setAlertMsg("");
    setAlertIcon("error");
  };

  useEffect(() => {
    getDashboardData();
  }, []);
  // render
  // render

  return (
    <>
      <Box padding={2}>
        <Typography
          variant="h5"
          fontWeight={"bold"}
          component={"span"}
          sx={{
            paddingBottom: 2,

            textTransform: "uppercase",
          }}
        >
          Requests Recieved
        </Typography>
        <Typography color={"text.grayText"}>Most Recent</Typography>

        <Box marginTop={2} display={"flex"} justifyContent={"flex-end"}>
          <TextField
            size="small"
            placeholder="Search"
            InputProps={{
              endAdornment: (
                <SearchIcon
                  sx={{
                    color: theme.palette.primary.dark,
                  }}
                />
              ),
            }}
            sx={{
              borderRadius: 25,
              backgroundColor: theme.palette.secondary.dark,
              ".MuiOutlinedInput-root": {
                borderRadius: 25,
                paddingX: 2,
              },
            }}
          ></TextField>
        </Box>
        <Box>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headings?.map((h, index) => {
                    if (index < 3) {
                      return (
                        <TableCell
                          align="center"
                          key={`${index}-table-heading-${h}`}
                        >
                          <Chip
                            label={h}
                            sx={{
                              backgroundColor: `${theme.palette.secondary.dark}`,
                              borderRadius: 2,
                              color: "blue",
                            }}
                          ></Chip>
                        </TableCell>
                      );
                    }

                    if (index === 3) {
                      return (
                        <TableCell
                          align="center"
                          key={`${index}-table-heading-${h}`}
                        >
                          <Chip
                            label={h}
                            sx={{
                              color: "red",
                              backgroundColor: "#FFD8D8",
                              borderRadius: 2,
                            }}
                          ></Chip>
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length > 0 ? (
                  tableData?.map((row, index) => (
                    <TableRow key={`${index}-row.name-${index + 2}`}>
                      <TableCell align="center">{row?.sender_name}</TableCell>

                      <TableCell align="center">
                        {row?.created_at
                          ? format(new Date(), "dd-MM-yyyy")
                          : ""}
                      </TableCell>
                      <TableCell align="center">{row?.quantity}</TableCell>

                      <TableCell align="center">
                        <Button
                          color="primary"
                          variant="contained"
                          size="small"
                          onClick={addHandler}
                          sx={{
                            borderRadius: 1,
                            minWidth: 2,
                            paddingX: 1,
                          }}
                        >
                          <DetailsIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    {" "}
                    <TableCell colSpan={4}>
                      {" "}
                      <Typography
                        variant="body1"
                        width={"100%"}
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        No Data Found
                      </Typography>{" "}
                    </TableCell>{" "}
                  </TableRow>
                )}{" "}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={loaderOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleAlertClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Seemore;
